export enum FUNCTION_MODULE {
  EXTEND_REGISTRATION_FEE = 'EXTEND_REGISTRATION_FEE',
  COMMENCE_OF_STUDY = 'COMMENCE_OF_STUDY',
  CHANGE_SUPERVISOR = 'CHANGE_SUPERVISOR',
  REJECT_APPLICATION = 'REJECT_APPLICATION',
  DECLINE_APPLICATION = 'DECLINE_APPLICATION',
}
